import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useMemo } from "react";
import { DayPicker } from "react-day-picker";
import { ArrowLeftIcon } from "../../icons/ArrowLeftIcon";
import { ArrowRightIcon } from "../../icons/ArrowRightIcon";
import { useStringMap } from "../../utilities/string-map/useStringMap";
import * as Styled from "./DateCalendar.styled";
import { Day } from "./Day";
import { HeadRow } from "./HeadRow";
import { WeekNumber } from "./WeekNumber";
import { Caption } from "./Caption";
import { DateCalendarContext } from "./DateCalendarContext";
import { stringMapDefault } from "./DateCalendar.stringMap";
export const DateCalendar = forwardRef(({ components, isInline, style, className, stringMap: stringMapProp, ...props }, ref) => {
    const stringMap = useStringMap("DateCalendar", { stringMapDefault, stringMapProp });
    const contextValue = useMemo(() => ({ stringMap }), [stringMap]);
    return (_jsx(DateCalendarContext.Provider, { value: contextValue, children: _jsx(Styled.DateCalendar, { "data-testid": "DateCalendar", ref: ref, className: className, style: style, isInline: isInline, children: _jsx(DayPicker, { mode: "default", components: {
                    HeadRow,
                    Caption,
                    IconRight: (props) => _jsx(ArrowRightIcon, { size: 24, ...props, "aria-hidden": "true" }),
                    IconLeft: (props) => _jsx(ArrowLeftIcon, { size: 24, ...props, "aria-hidden": "true" }),
                    WeekNumber,
                    Day,
                    ...components
                }, ...props }) }) }));
});
DateCalendar.displayName = "DateCalendar";
